import { useContext } from "react";
import { FilterMetadataContext } from "./context";

export const useFilterMetadata = () => {
  const c = useContext(FilterMetadataContext);
  if (!c) {
    throw new Error("No FilterMetadataContext context was provided.");
  }
  return c;
};
